import { CommonUtils, Factory } from '@infodata-group/inf-commons';
import { DaysOff } from '../model/days-off';

export class DaysOffFactory implements Factory<DaysOff[]> {
  constructor(
    private dateStart: string,
    private dateEnd: string,
    private operatorId?: string,
  ) {}

  build(o: any): DaysOff[] {
    const daysOff = [];
    for (const operator of o) {
      const operatorDaysOff = new DaysOff();
      operatorDaysOff.id = operator.id;
      for (const day of operator.days) {
        if (day.date !== '') {
          const start = CommonUtils.convertStrToTime(day.startTime);
          const end = CommonUtils.convertStrToTime(day.endTime);
          const date = CommonUtils.convertStrToDate(day.date);
          operatorDaysOff.days.push({
            date: date,
            startTime: start,
            endTime: end,
            halfDay: day.halfDay,
          });
        }
      }
      daysOff.push(operatorDaysOff);
    }
    return daysOff;
  }

  getApi(): string {
    const url = `daysOff?dateStart=${this.dateStart}&dateEnd=${this.dateEnd}`;
    return this.operatorId ? `${url}&operatorId=${this.operatorId}` : url;
  }
}
